import React from 'react';
import { PermissionContext } from 'core';

export default React.createContext<PermissionContext | null>(null);
